{
  "forms": {
    "none": "Aucun"
  },
  "create": {
    "modal_title": "Créer une nouvelle colonne",
    "column_name_label": "Nom de la colonne",
    "add_column_button": "Ajouter une colonne",
    "add_column_aria_label": "Ajouter une colonne",
    "validation": {
      "name_required": "Veuillez choisir un nom pour le nouveau champ",
      "type_required": "Veuillez sélectionner un type pour le nouveau champ",
      "options_required": "Veuillez nous dire quelles sont les options",
      "currency_required": "Veuillez sélectionner une devise"
    },
    "yes_no_options": {
      "yes": "Oui",
      "no": "Non"
    }
  },
  "value_type": {
    "label": "Type de valeur"
  },
  "value_types": {
    "date": "Date",
    "multi_select": "Sélection multiple",
    "select": "Sélection",
    "number": "Nombre",
    "rich_text": "Texte riche",
    "text": "Texte",
    "employee": "Employé",
    "employees": "Employés",
    "contacts": "Contacts",
    "companies": "Entreprises",
    "currency": "Devise",
    "yes_no_option": "Option Oui/Non",
    "countries": "Pays",
    "date_time": "Date et heure"
  },
  "remove": {
    "confirmation_title": "Êtes-vous sûr de vouloir supprimer ce champ ?",
    "aria_label": "supprimer le champ personnalisé"
  },
  "options": {
    "modal_title": "Nouvelles options",
    "add_button": "Option",
    "value_label": "Valeur de l'option",
    "remove_aria_label": "supprimer l'option",
    "validation": {
      "values_required": "Veuillez saisir les nouvelles valeurs"
    },
    "update": {
      "modal_title": "Mettre à jour la valeur de l'option",
      "value_label": "Valeur de l'option",
      "validation": {
        "value_required": "Veuillez saisir une valeur",
        "colour_required": "Veuillez sélectionner une couleur"
      }
    },
    "new_chip_label": "Nouvelles options"
  },
  "schema": {
    "update_aria_label": "mettre à jour le schéma de champ personnalisé",
    "edit_title": "Modifier le champ",
    "field_name_label": "Nom du champ",
    "campaigns_using_filter_one": "{{campaignNames}} est en train d'utiliser ce champ comme filtre. Veuillez annuler la programmation de la campagne avant de supprimer le champ.",
    "campaigns_using_filter_other": "{{campaignNames}} sont en train d'utiliser ce champ comme filtre. Veuillez annuler la programmation de ces campagnes avant de supprimer le champ."
  },
  "accessibility": {
    "info_tooltip": "Info"
  }
}
